import { SDK_VERSION } from './utils-hoist/version.js';
import { GLOBAL_OBJ } from './utils-hoist/worldwide.js';
/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/

function getMainCarrier() {
  // This ensures a Sentry carrier exists
  getSentryCarrier(GLOBAL_OBJ);
  return GLOBAL_OBJ;
}
/** Will either get the existing sentry carrier, or create a new one. */


function getSentryCarrier(carrier) {
  var __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {}; // For now: First SDK that sets the .version property wins


  __SENTRY__.version = __SENTRY__.version || SDK_VERSION; // Intentionally populating and returning the version of "this" SDK instance
  // rather than what's set in .version so that "this" SDK always gets its carrier

  return __SENTRY__[SDK_VERSION] = __SENTRY__[SDK_VERSION] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */


function getGlobalSingleton(name, creator) {
  var obj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : GLOBAL_OBJ;

  var __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};

  var carrier = __SENTRY__[SDK_VERSION] = __SENTRY__[SDK_VERSION] || {}; // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes

  return carrier[name] || (carrier[name] = creator());
}

export { getGlobalSingleton, getMainCarrier, getSentryCarrier };